export default "__VITE_ASSET__DfgkhBl7__"